export default "__VITE_ASSET__40370f60__"